import { BooleanField, Datagrid, EmailField, FormTab, ListButton, ReferenceManyField, Show, TabbedForm, TextField } from "react-admin"


const CustomActions = (props) => {
    return <>
        <ListButton label="Retornar" variant="contained" style={{ marginBlock: '16px' }} />
    </>
}


const ClassShow = (props) => {

    return (
        <Show
            actions={<CustomActions {...props} />}
            {...props}
        >
            <TabbedForm>
                <FormTab label={'Dados Gerais'}>
                    <TextField source="name" label={'Nome'} fullWidth />
                    <TextField source="description" label={'Descrição'} fullWidth />
                    <TextField label="Período letivo" source="academic_period.name" fullWidth />
                    <BooleanField label="Turma com acesso ao Juristta Office?" source="has_office_access" fullWidth />
                </FormTab>
                <FormTab label={'Alunos'}>
                    <ReferenceManyField fullWidth reference="user-contexts" target='classId' sort={{ field: 'user.name', order: 'ASC' }} label={'Alunos'}>
                        <Datagrid>
                            <TextField source='user.name' label={'Nome'} fullWidth />
                            <EmailField source='user.email' label={'Email'} fullWidth />
                        </Datagrid>
                    </ReferenceManyField>
                </FormTab>
            </TabbedForm>
        </Show>
    )
}

export default ClassShow